export default "__VITE_ASSET__CIjyKaGj__"